import { combineReducers } from 'redux';
import seo from './seo';
import organizations from './organizations';
import products from './products';
import currencies from './currencies';
import updatedDate from './updatedDate';
var rootReducer = combineReducers({
  seo: seo,
  organizations: organizations,
  updatedDate: updatedDate,
  products: products,
  currencies: currencies
});
export default rootReducer;